import axios from 'axios'
import { API_BASE_URL } from '../config/api'
import { storageGet, storageRemove } from '../utils/safeStorage'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Interceptor para adicionar token de autenticação quando necessário
api.interceptors.request.use(
  (config) => {
    const token = storageGet('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (
        error.response.status === 428 &&
        error.response.data?.code === 'MFA_CHALLENGE_REQUIRED' &&
        !error.config?._retryMfa
      ) {
        const originalRequest = error.config
        originalRequest._retryMfa = true

        const action = error.response.data?.action || 'critical_action'
        const code = window.prompt('Informe o código do autenticador para confirmar esta ação crítica:')
        if (!code) {
          return Promise.reject(new Error('Ação cancelada: código do autenticador não informado.'))
        }

        let tenantId = null
        try {
          const rawUser = storageGet('user')
          if (rawUser) {
            const user = JSON.parse(rawUser)
            tenantId = user?.tenantId || user?.TenantId || null
          }
        } catch {
          tenantId = null
        }

        return api
          .post('/auth/mfa/challenge', {
            code,
            action,
            tenantId,
          })
          .then((challengeResponse) => {
            const actionToken = challengeResponse.data?.actionToken || challengeResponse.data?.ActionToken
            if (!actionToken) {
              throw new Error('Não foi possível validar o autenticador para esta ação.')
            }
            originalRequest.headers = originalRequest.headers || {}
            originalRequest.headers['X-MFA-Action-Token'] = actionToken
            return api(originalRequest)
          })
      }

      // Se receber 401 (Unauthorized), limpar autenticação e redirecionar para login
      if (error.response.status === 401) {
        const reqUrl = error.config?.url || ''
        const isChangePassword = reqUrl.includes('/auth/change-password')
        if (!isChangePassword) {
          storageRemove('token')
          storageRemove('user')
          if (window.location.pathname !== '/login' && window.location.pathname !== '/definir-senha') {
            window.location.href = '/login'
          }
        }
      }
      
      if (error.response.status === 403 && error.response.data?.code === 'MUST_CHANGE_PASSWORD') {
        if (!window.location.pathname.includes('definir-senha')) {
          window.location.assign('/definir-senha')
        }
      }

      if (error.response.status === 403 && error.response.data?.code === 'MFA_REQUIRED_FOR_CRITICAL_ACTION') {
        return Promise.reject(new Error('Para esta ação crítica, ative o autenticador em Configurações > Segurança.'))
      }

      const data = error.response.data
      const message =
        (typeof data === 'string' && data) ||
        data?.message ||
        data?.Message ||
        data?.error ||
        data?.Error ||
        'Erro ao processar requisição'
      return Promise.reject(new Error(message))
    } else if (error.request) {
      // Erro de rede
      return Promise.reject(new Error('Erro de conexão. Verifique sua internet.'))
    } else {
      return Promise.reject(error)
    }
  }
)

export default api

